import { formatMoney, parseMoney } from '@bqcrm/shared';
import { TextInput, type TextInputProps } from '@mantine/core';
import { useEffect, useState } from 'react';

/** Kwota: wyświetlanie po polsku (odstęp tysięcy, przecinek dziesiętny). */
export const Money = ({ gr, currency = true }: { gr: number | null | undefined; currency?: boolean }) => (
  <span style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{gr === null || gr === undefined ? '—' : formatMoney(gr, currency)}</span>
);

/** Pole kwoty w złotych; wartość w groszach. Akceptuje „1 234,56” i „1234.56”. */
export function MoneyInput({ valueGr, onChangeGr, ...rest }: { valueGr: number | null; onChangeGr: (gr: number | null) => void } & Omit<TextInputProps, 'value' | 'onChange'>) {
  const fmt = (gr: number | null) => (gr === null ? '' : formatMoney(gr, false));
  const [text, setText] = useState(fmt(valueGr));
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (!focused) setText(fmt(valueGr));
  }, [valueGr, focused]);
  const invalid = text.trim() !== '' && parseMoney(text) === null;
  return (
    <TextInput
      {...rest}
      value={text}
      error={invalid ? 'Niepoprawna kwota' : rest.error}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false);
        const v = text.trim() === '' ? null : parseMoney(text);
        if (v !== null || text.trim() === '') onChangeGr(v);
        setText(fmt(v ?? valueGr));
      }}
      onChange={(e) => {
        setText(e.currentTarget.value);
        const v = parseMoney(e.currentTarget.value);
        if (v !== null) onChangeGr(v);
      }}
      styles={{ input: { textAlign: 'right', fontVariantNumeric: 'tabular-nums' } }}
    />
  );
}
